import React from 'react';
import skylarqLogo from '../../../assets/skylarq_logo_small.png';

interface SkylarqAvatarProps {
  size?: 'sm' | 'md';
  className?: string;
}

/**
 * Reusable Skylarq avatar component for chat messages
 * Centralizes the logo display pattern used across chat components
 */
export const SkylarqAvatar: React.FC<SkylarqAvatarProps> = ({
  size = 'md',
  className = '',
}) => {
  const sizeClasses = size === 'sm' ? 'w-6 h-6' : 'w-7 h-7';

  return (
    <img
      src={skylarqLogo}
      alt=""
      className={`${sizeClasses} object-contain flex-shrink-0 ${className}`}
    />
  );
};
